import { render } from "./Footer.vue?vue&type=template&id=2a829b4a&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=2a829b4a&scoped=true&lang=css"
import "./Footer.vue?vue&type=style&index=1&id=2a829b4a&scoped=true&lang=css"

import exportComponent from "/Users/admin/Work/IKENTAI_HOME/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a829b4a"]])

export default __exports__